import { useEffect, useRef, useState } from "react";
import { Chip, chipClasses, ChipProps, Tooltip } from "@mui/material";

interface TooltipChipProps extends ChipProps {
  label: string;
}

const TooltipChip = (props: TooltipChipProps) => {
  const { label, ...chipProps } = props;
  const chipRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (chipRef.current) {
      const labelElement = chipRef.current.querySelector(`.${chipClasses.label}`);
      if (labelElement) {
        const isTextOverflowing = labelElement.scrollWidth > labelElement.clientWidth;
        setIsOverflowing(isTextOverflowing);
      }
    }
  }, [label]);

  return (
    <Tooltip
      arrow
      title={isOverflowing ? label : null}
      enterDelay={750}
      enterNextDelay={750}
      componentsProps={{ tooltip: { sx: { maxWidth: 750 } } }}
    >
      <Chip ref={chipRef} label={label} {...chipProps} />
    </Tooltip>
  );
};

export default TooltipChip;
